// Single query that drives every tab, the reference line, and the
// Needs Configuration donut chart on the Brands page. Per spec, the frontend
// computes no status/membership logic beyond what this response already flags.
export const BRANDS_QUERY_ID = "5729017198018560";

// Same query IDs the legacy Brand Configuration Report module's Overview
// screen uses for the Run Process wizard's "By Flow" destination-table
// resolution — called via BrandsEndPointLogic (its own copy of the request
// logic), not the legacy logic file. Both are site-wide (not brand-scoped)
// queries, so they're safe to call from this page too. The new Brands query
// (BRANDS_QUERY_ID) doesn't carry per-brand raw-table data, so "By Report"
// options are built from the fetcher config query instead — see
// getRowOutputTableData in utils/ensureRunProcessSupportData.ts.
export const RUN_PROCESS_FETCHER_CONFIG_QUERY_ID = "5652708983832576";
export const RUN_PROCESS_INDUSTRY_QUERY_ID = "5171209863954432";
